import React from 'react';
import PropTypes from 'prop-types';
import { group, stringInputSpec } from './editing-configs';

const defaultDimensions = {
  height: '232px',
  width: '100%',
};

export const extractEpisodeId = (url) => {
  const episode = url.match(/.*\/(.*)\/(.*)\?(.*)$/) || [];
  if (episode && episode.length && episode[2]) {
    return episode[2];
  }
  return null;
};

const SpotifyPlayer = ({
  spotifyEpisodeUrl,
  podcastMediaWidth = defaultDimensions.width,
  podcastMediaHight = defaultDimensions.height,
}) => {
  const episode = extractEpisodeId(spotifyEpisodeUrl);
  const src = `https://open.spotify.com/embed/episode/${episode}?utm_source=generator`;

  if (!episode) {
    return null;
  }

  return (
    <iframe
      id="spotify-iframe"
      src={src}
      width={podcastMediaWidth || defaultDimensions.width}
      height={podcastMediaHight || defaultDimensions.height}
      frameBorder="0"
      title="Spotify Podcast"
    />
  );
};

SpotifyPlayer.propTypes = {
  spotifyEpisodeUrl: PropTypes.string,
  podcastMediaWidth: PropTypes.string,
  podcastMediaHight: PropTypes.string,
};

SpotifyPlayer.defaultProps = {
  spotifyEpisodeUrl: '',
  podcastMediaWidth: '',
  podcastMediaHight: '',
};

SpotifyPlayer.getEditingConfigs = (_componentDocument, fieldName) => {
  const getInputName = (name) => (fieldName ? `${fieldName}.${name}` : name);
  return [
    stringInputSpec(getInputName('spotifyEpisodeUrl'), 'Podcast episode URL'),
    group('Audio Details', [
      {
        help: 'The desired Spotify podcast episode URL',
      },
      stringInputSpec(getInputName('podcastMediaHight'), 'Podcast height', {
        help: 'The podcast frame height in pixels. Default value is 232px',
      }),
      stringInputSpec(getInputName('podcastMediaWidth'), 'Podcast width', {
        help: 'The podcast frame width in pixels or percentage. Default value is 100%',
      }),
    ]),
  ];
};

export default SpotifyPlayer;
